import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Circle, Path } from "react-native-svg";

export const IconPeopleVoice: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconPeopleVoice"><Path d="M20.5 8V12M17.5 3V17M14.5 6V14M11.5 4V8" stroke="currentColor"/><Path d="M3.5 20.5V20C3.5 17.5147 5.51472 15.5 8 15.5C10.4853 15.5 12.5 17.5147 12.5 20V20.5H3.5Z" stroke="currentColor"/><Circle cx="8" cy="11.5" r="2" stroke="currentColor"/></CentralIconBase>;
});

export default IconPeopleVoice;
